import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CompHero from './components/CompHero';
import CompHow from './components/CompHow';
import CompPricing from './components/CompPricing';
import CompCTA from './components/CompCTA';

export default function Competitors() {
  return (
    <main>
      <Navbar />
      <CompHero />
      <CompHow />
      <CompPricing />
      <CompCTA />
      <Footer />
    </main>
  );
}